import React from 'react'

const Heading = ({ title }: {title: string}) => {
  return (
    <h1 className='heading-component text-center'>{title}</h1>
  )
}

export default Heading